import { render } from "./UpdateTask.vue?vue&type=template&id=0da5465d&scoped=true"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"

import "./UpdateTask.vue?vue&type=style&index=0&id=0da5465d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da5465d"]])

export default __exports__